import { useMemo, useState } from 'react'
import * as BalancaHttp from '../../../../services/api/https/patio/balanca.http'
import { errorHandler } from '../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  INITIAL_GET: 'Adquirindo informações das balanças',
}

const INITIAL_STATE = {
  balancas: [],
  modal: { show: false, data: null },
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  selectedTp: 0,
  globalFilter: '',
}

export default function useBalanca() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      async getBalancas(tp_id) {
        try {
          const list = await BalancaHttp.getBalancas(tp_id)
          setState(prev => ({
            ...prev,
            balancas: list,
            loadingMessage: LOAD_MESSAGE.NONE,
          }))
        } catch (err) {
          setState(prev => ({
            ...prev,
            loadingMessage: LOAD_MESSAGE.NONE,
            errorMessage: errorHandler(err),
          }))
        }
      },
      resetState() {
        setState({ ...INITIAL_STATE })
      },
      onInit(selectedTp) {
        setState(prev => ({
          ...prev,
          selectedTp: selectedTp,
          loadingMessage: selectedTp ? LOAD_MESSAGE.INITIAL_GET : LOAD_MESSAGE.NONE,
          errorMessage: selectedTp ? null : 'Selecione um TP',
        }))
      },
      onBtnNovo() {
        setState(prev => ({ ...prev, modal: { show: true, data: null } }))
      },
      onModalClose() {
        setState(prev => ({ ...prev, modal: { show: false, data: null } }))
      },
      onModalSave(balanca) {
        setState(prev => {
          const copy = { ...prev }
          copy.modal = { show: false, data: null }
          const idx = copy.balancas.findIndex(b => b.id === balanca.id)
          if (idx !== -1) copy.balancas[idx] = balanca
          else copy.balancas.unshift(balanca)
          return copy
        })
      },
      onGlobalFilterChange(value) {
        setState(prev => ({ ...prev, globalFilter: value }))
      },
      onRowClick(balanca) {
        setState(prev => ({ ...prev, modal: { show: true, data: balanca } }))
      },
    }
  }, [])

  return { state, localDispatch }
}
